import { Box, Button, Modal, TextField } from '@mui/material'
import React from 'react'

export default function EditContact({
  open, 
  handleClose, 
  handleSubmit, 
  setName, 
  setNumber,
  name,
  number
}) {
    return (
      <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
          <Box
            container
            boxShadow={3}
            display="flex"
            textAlign="center"
            sx={{
              width: '40vw',
              position: 'absolute',
              top: '40%',
              left: '15%',
              backgroundColor: '#172067'
          }}>
            <Box component="form" onSubmit={handleSubmit} sx={{ mx: 'auto', width: '70%' }}>
              <TextField
              onChange={e => setName(e.target.value)}
              value={name}
              color="secondary"
              margin="normal"
              required
              fullWidth
              label="Name"
              autoFocus
              error={name === ""}
              helperText={name === "" ? "Empty!" : " "}
              />
              <TextField
              onChange={e => setNumber(e.target.value)}
              value={number}
              color="secondary"
              margin="normal"
              required
              fullWidth
              label="Number (4168999137)"
              error={number === ""}
              helperText={number === "" ? "Empty!" : " "}
              />
              <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              sx={{ mt: 3, mb: 2 }}
              >
              Edit Contact
              </Button>
            </Box>
          </Box>
      </Modal>
    )
}
